import React from 'react';
import { Link } from 'react-router-dom';
import { TrainFront, Phone, ExternalLink } from 'lucide-react';
import './Footer.css';

export const Footer: React.FC = () => {
  return (
    <footer className="app-footer" aria-label="Site Footer">
      <div className="app-footer__inner">

        {/* Brand Column */}
        <div className="app-footer__brand">
          <Link to="/" className="app-footer__brand-row" aria-label="YatriGo Home">
            <div className="app-footer__logo">
              <TrainFront size={16} />
            </div>
            <span className="app-footer__name">YatriGo</span>
          </Link>
          <p className="app-footer__tagline">
            The social media of journeys. Track trains, share updates, and connect with fellow travelers across the Indian Railways network.
          </p>
        </div>

        {/* Column 1: Services */}
        <nav className="app-footer__col">
          <h3 className="app-footer__col-title">Services</h3>
          <Link to="/trains" className="app-footer__link">Train Search</Link>
          <Link to="/pnr" className="app-footer__link">PNR Status</Link>
          <Link to="/live" className="app-footer__link">Live Tracking</Link>
          <Link to="/stations" className="app-footer__link">Stations Directory</Link>
        </nav>

        {/* Column 2: Community */}
        <nav className="app-footer__col">
          <h3 className="app-footer__col-title">Community</h3>
          <Link to="/community" className="app-footer__link">Journey Feed</Link>
          <Link to="/forum" className="app-footer__link">Discussion Forum</Link>
          <Link to="/gallery" className="app-footer__link">Heritage Gallery</Link>
          <Link to="/tips" className="app-footer__link">Travel Tips</Link>
        </nav>

        {/* Column 3: Legal & Resources */}
        <nav className="app-footer__col">
          <h3 className="app-footer__col-title">Resources</h3>
          <Link to="/privacy-policy" className="app-footer__link">Privacy Policy</Link>
          <Link to="/terms" className="app-footer__link">Terms of Service</Link>
          <a
            href="https://www.indianrail.gov.in"
            target="_blank"
            rel="noopener noreferrer"
            className="app-footer__link"
            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            Indian Railways <ExternalLink size={12} />
          </a>
          <a href="tel:139" className="app-footer__link" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Phone size={12} /> Helpline 139
          </a>
        </nav>

      </div>

      {/* Bottom Bar */}
      <div className="app-footer__bottom">
        <span className="app-footer__copy">© 2026 YatriGo. All rights reserved.</span>
        
        <div className="app-footer__socials">
          <a href="#twitter" className="app-footer__social-btn" aria-label="Twitter">X</a>
          <a href="#github" className="app-footer__social-btn" aria-label="Github">GH</a>
          <a href="#linkedin" className="app-footer__social-btn" aria-label="LinkedIn">IN</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;